import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { ModuleOverview } from './components/ModuleOverview';
import { Login } from './components/Login';
import { User } from './components/UserManagement';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loginError, setLoginError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  // Check if user is already logged in on component mount
  useEffect(() => {
    const storedAuth = localStorage.getItem('auth');
    if (storedAuth) {
      try {
        const auth = JSON.parse(storedAuth);
        if (auth.isAuthenticated && auth.user) {
          setIsAuthenticated(true);
          setCurrentUser(auth.user);
        }
      } catch (e) {
        console.error('Failed to parse auth from localStorage', e);
      }
    }
    setIsLoading(false);
  }, []);
  const handleLogin = (username: string, password: string) => {
    // First check if we have any users in localStorage
    const storedUsers = localStorage.getItem('users');
    let users: User[] = [];
    if (storedUsers) {
      try {
        users = JSON.parse(storedUsers);
      } catch (e) {
        console.error('Failed to parse users from localStorage', e);
      }
    }
    // If we have no users, or it's the first login, create the admin user
    if (users.length === 0 && username === 'admin' && password === '123') {
      const adminUser: User = {
        id: 'admin-1',
        username: 'admin',
        password: '123',
        permissions: [] // Admin has access to all modules by default
      };
      users.push(adminUser);
      localStorage.setItem('users', JSON.stringify(users));
      setCurrentUser(adminUser);
      setIsAuthenticated(true);
      localStorage.setItem('auth', JSON.stringify({
        isAuthenticated: true,
        user: adminUser
      }));
      return;
    }
    // Check if the user exists and password matches
    const user = users.find(u => u.username === username && u.password === password);
    if (user) {
      setCurrentUser(user);
      setIsAuthenticated(true);
      setLoginError(null);
      // Store auth state in localStorage
      localStorage.setItem('auth', JSON.stringify({
        isAuthenticated: true,
        user
      }));
    } else {
      setLoginError('Ungültiger Benutzername oder Passwort');
    }
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentUser(null);
    localStorage.removeItem('auth');
  };
  if (isLoading) {
    return <div className="fixed inset-0 bg-white/70 backdrop-blur-sm z-50 flex items-center justify-center" data-id="element-0">
        <div className="w-12 h-12 border-4 border-[#8DC63F] border-t-transparent rounded-full animate-spin" data-id="element-1"></div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} loginError={loginError} data-id="element-2" />;
  }
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-br from-gray-50 to-gray-100" data-id="element-3">
      <Header currentUser={currentUser} onLogout={handleLogout} data-id="element-4" />
      <main className="flex-1 p-6 md:p-8" data-id="element-5">
        <ModuleOverview currentUser={currentUser} data-id="element-6" />
      </main>
    </div>;
}